<template>
  <div class="VueBox">
    <div>
      <linkTitle />
    </div>

    <div id="settingPage">
      <div>
        <PageSearchTitle :hideCart="true" />
      </div>
      <div class="settPageBox">
        <div class="settingPageLeft">
          <div class="settingPageLeftTitle">账号管理</div>
          <el-tabs :value="tabValue" @tab-click="tabClick" tab-position="left">
            <el-tab-pane v-if='userInfo&&userInfo.access_token' name="addressSetting" label="收货地址"
              ><AddressSetting></AddressSetting
            ></el-tab-pane>
            <el-tab-pane v-if='userInfo&&userInfo.access_token' name="settingPwd" label="预设支付密码"
              ><SettingPwd></SettingPwd
            ></el-tab-pane>
            <el-tab-pane v-if='userInfo&&userInfo.access_token' name="resetPayPwd" label="重置支付密码"
              ><ResetPayPwd></ResetPayPwd
            ></el-tab-pane>
            <el-tab-pane name="resetLoginPwd" label="重置登录密码"
              ><ResetLoginPwd></ResetLoginPwd>
            </el-tab-pane>
            <el-tab-pane v-if='userInfo&&userInfo.access_token' name="invoiceControl" label="发票管理"
              ><InvoiceControl></InvoiceControl>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import AddressSetting from "@/components/SettingPage/components/AddressSetting";
import SettingPwd from "@/components/SettingPage/components/SettingPwd";
import ResetLoginPwd from "@/components/SettingPage/components/ResetLoginPwd";
import ResetPayPwd from "@/components/SettingPage/components/ResetPayPwd";
import InvoiceControl from "@/components/SettingPage/components/InvoiceControl";

import { mapState } from "vuex";


export default {
  data: function () {
    return {
      tabValue: "addressSetting",
    };
  },
  mounted() {
    let type = this.$route.query.type;
    if (type) {
      this.tabValue = type;
    }
    if(!(this.userInfo&&this.userInfo.access_token)){
       this.tabValue = 'resetLoginPwd'
    }
  },
  methods: {
    tabClick(e) {
      console.log(e);
    },
  },
  computed:{
    ...mapState(['userInfo'])
  },
  components: {
    PageSearchTitle,
    AddressSetting,
    SettingPwd,
    ResetLoginPwd,
    ResetPayPwd,
    InvoiceControl
  },
};
</script>

<style lang='less' scoped>
@media screen and(min-width:320px) and(max-width:1200px) {
  #settingPage {
    padding: 10px !important;
  }
}
.VueBox {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
#settingPage {
  padding: 10px 150px;
  min-width: 1000px;
  //   background-color: red;

  flex: 1;
}
.settingPageLeftItemBox {
  font-size: 14px;
  color: #333;
}
.settingPageLeftTitle {
  color: #f40;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  margin-left: 70px;
}
.settingPageLeftItem {
  margin: 10px 0;
  color: #666;
}
.settPageBox {
  margin-top: 10px;
  display: flex;
}
.settingPageLeft {
  // width: 150px;
  // background-color: #f1f1f1;
}
.settingPageLeftItem:hover {
  color: #f40;
  cursor: pointer;
}
.settingPageRight {
  margin-left: 40px;
  flex: 1;
}
.settingPageRightTitle {
  background-color: #f3f8fe;
  height: 30px;
  line-height: 30px;
  margin: 40px 0 10px 0;
  font-size: 14px;
  color: #014d7f;
  padding-left: 10px;
}
.settingPageRightContentTitle {
  font-size: 14px;
  color: #f40;
  height: 40px;
  line-height: 40px;
  position: relative;
  left: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SettingPage/SettingPage.vue